export function formatDate(startDate, endDate = null) {
  let start = startDate
  let end = endDate
  const formatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const replaceDash = (d) =>
    d
      .replace(/-/g, '/')
      .split(' ')[0]
      .toString()
  // @ts-ignore
  const createDate = (date) => new Date(replaceDash(date)).toLocaleDateString('en-GB', formatOptions)

  if (start && start.includes('-')) {
    start = createDate(start)
  }
  if (end && end.includes('-')) {
    end = createDate(end)
  }

  return !end ? start : `${start} - ${end}`
}

/* if the date format is in this format "16/07/2025 15:30", then I want it to become "yyyy-MM-dd HH:mm" */

export const formatSheduledDate = (data) => {
  if (typeof data !== 'string') return data

  // Match dd/MM/yyyy HH:mm or dd-MM-yyyy HH:mm
  const dateMatch = data.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4}) (\d{2}):(\d{2})$/)
  if (dateMatch) {
    // Rearrange to yyyy-MM-dd HH:mm
    const [, day, month, year, hour, minute] = dateMatch
    return `${year}-${month}-${day} ${hour}:${minute}`
  }

  /* if the date format is in this format "Fri May 30 2025 13:45:00 GMT+0100 (Western European Summer Time)", then I want it to become "yyyy-MM-dd HH:mm" */
  const jsDateMatch = data.match(/^\w{3} \w{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT\+\d{4} \(.*\)$/)
  if (jsDateMatch) {
    const dateObj = new Date(data)
    if (!isNaN(dateObj.getTime())) {
      const pad = (n) => n.toString().padStart(2, '0')
      return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())} ${pad(
        dateObj.getHours()
      )}:${pad(dateObj.getMinutes())}`
    }
  }

  return data
}

// you get "31/05/2025 14:00" and you will return "yyyy-MM-dd HH:mm"
export const parseDateForSchedule = (dateStr: string | Date): Date | null => {
  if (typeof dateStr === 'string') {
    // Match dd/MM/yyyy HH:mm or dd-MM-yyyy HH:mm
    const dateMatch = dateStr.match(/^(\d{2})[\/\-](\d{2})[\/\-](\d{4}) (\d{2}):(\d{2})$/)
    if (dateMatch) {
      const [, day, month, year, hour, minute] = dateMatch
      return new Date(`${year}-${month}-${day}T${hour}:${minute}:00`)
    } else {
      // Try to parse as JS Date string
      const tryDate = new Date(dateStr)
      if (!isNaN(tryDate.getTime())) {
        return tryDate
      }
    }
  } else if (dateStr instanceof Date && !isNaN(dateStr.getTime())) {
    return dateStr
  }
  return null
}

// Format a Date object as 'yyyy-MM-dd HH:mm' in local time
export function formatDateLocal(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

// Returns a string in 'yyyy-MM-dd HH:mm' (local time) if Date, uses formatSheduledDate if string, or null otherwise
export function getScheduledDateString(value: Date | string | undefined | null): string | null {
  if (value && (value as unknown) instanceof Date) {
    return formatDateLocal(value as Date)
  }
  if (typeof value === 'string') {
    return formatSheduledDate(value)
  }
  return null
}

export default {}
